import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, forwardRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { LocalService } from './local.service';

export type NcSizeType = 'small' | 'default' | 'large';

@Component({
  selector: 'nc-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OtpComponent),
      multi: true
    }
  ]
})
export class OtpComponent implements OnInit, AfterViewInit, OnDestroy {
  /** 自定义输入框个数 */
  @Input() ncLength: number = 6;
  /** 输入框大小 */
  @Input() ncSize: NcSizeType = 'default';
  /** 是否禁用 */
  private _disabled: boolean = false;
  @Input() set ncDisabled(value: boolean | string) {
    this._disabled = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncDisabled(): boolean {
    return this._disabled;
  }
  /** 是否只读 */
  private _readonly: boolean = false;
  @Input() set ncReadonly(value: boolean | string) {
    this._readonly = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncReadonly(): boolean {
    return this._readonly;
  }
  /** 隐藏输入值 */
  private _mask: boolean = false;
  @Input() set ncMask(value: boolean | string) {
    this._mask = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncMask(): boolean {
    return this._mask;
  }
  /** 是否为简单模式 */
  private _simple: boolean = false;
  @Input() set ncSimple(value: boolean | string) {
    this._simple = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncSimple(): boolean {
    return this._simple;
  }
  /** 是否只允许输入数字 */
  private _integerOnly: boolean = false;
  @Input() set ncIntegerOnly(value: boolean | string) {
    this._integerOnly = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncIntegerOnly(): boolean {
    return this._integerOnly;
  }
  /** 是否自动聚焦 */
  private _autofocus: boolean = false;
  @Input() set ncAutofocus(value: boolean | string) {
    this._autofocus = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncAutofocus(): boolean {
    return this._autofocus;
  }

  inputArr: Array<any> = [];
  innerValue: Array<any> = [];
  curIndex: number = -1;
  inputDoms: Array<HTMLInputElement> = [];
  canCopy: boolean = false;
  private onChangeCallback: (_: any) => void = () => { };
  private onTouchedCallback: () => void = () => { };

  constructor(private eleRef: ElementRef, private cd: ChangeDetectorRef, private ls: LocalService) { }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.curIndex == -1) {
      return;
    }

    if (event.ctrlKey && (event.key == "v" || event.key === "V")) {
      //防止ctrl+v时v执行nextInput
      return;
    }

    if (event.code == 'Space') {
      event.preventDefault();
      return;
    }

    if (event.key == 'Backspace' || event.key == 'Delete') {
      setTimeout(() => {
        //先执行删除操作，再执行lastInput
        this.lastInput(this.curIndex);
      })
      return;
    }

    if (event.key == 'ArrowLeft') {
      setTimeout(() => {
        this.lastInput(this.curIndex);
      })
      return;
    }

    if (event.key == 'ArrowRight') {
      setTimeout(() => {
        this.nextInput(this.curIndex);
      })
      return;
    }

    if (this.ncIntegerOnly) {
      if (!(/^[0-9]{1}$/.test(event.key))) {
        event.preventDefault();
      } else {
        setTimeout(() => {
          //先执行输入操作，再执行nextInput
          this.nextInput(this.curIndex);
        })
      }
    } else {
      if (/^[a-zA-Z0-9]{1}$/.test(event.key)) {
        setTimeout(() => {
          //先执行输入操作，再执行nextInput
          this.nextInput(this.curIndex);
        })
      }
    }
  }

  ngOnInit(): void {
    this.inputArr = Array.from({ length: this.ncLength });
  }

  ngAfterViewInit(): void {
    this.inputDoms = this.eleRef.nativeElement.querySelectorAll('.otp-input');
    if (this.ncAutofocus) {
      setTimeout(() => {
        this.inputDoms[0].focus();
      })
    }

    const otpContainer: HTMLElement = this.eleRef.nativeElement.querySelector(`.otp-container`);
    const parent = otpContainer.parentElement?.parentElement;//nc-otp的父级

    if (this.ls.isBrowser) {
      document.addEventListener('click', (event) => {
        //选中parent或parent内部元素
        if (event.target == parent || parent!.contains((event.target) as Node)) {
          this.canCopy = true;
        } else {
          this.canCopy = false;
        }
      })

      document.addEventListener('paste', (event) => {
        if (this.canCopy) {
          // 阻止默认粘贴行为
          event.preventDefault();

          // 获取剪贴板数据
          const clipboardData = event.clipboardData;
          let pastedData = clipboardData!.getData('Text');

          // 处理获取的文本数据
          if (pastedData && pastedData.length > 0 && !this.ncDisabled && !this.ncReadonly) {
            //删除空格
            pastedData = pastedData.replace(/\s+/g, '');
            let pastedDataArr: Array<string | number | null> = pastedData.split('');
            //integerOnlyMode下存在非数字中断粘贴
            if (this.ncIntegerOnly) {
              for (let d of pastedDataArr) {
                if (isNaN(Number(d))) {
                  return;
                }
              }
            }
            while (pastedDataArr.length < this.ncLength) {
              pastedDataArr.push(null);
            }
            if (pastedDataArr.length > this.ncLength) {
              pastedDataArr = pastedDataArr.slice(0, this.ncLength);
            }
            for (let i = 0; i < pastedDataArr.length; i++) {
              pastedDataArr[i] = !pastedDataArr[i] ? null : (isNaN(Number(pastedDataArr[i])) ? pastedDataArr[i] : Number(pastedDataArr[i]));
            }
            this.value = [...pastedDataArr];
          }
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.ls.isBrowser) {
      document.removeEventListener('click', () => { });
      document.removeEventListener('paste', () => { });
    }
  }

  inputFocus(index: number) {
    this.curIndex = index;
    const inputElement = this.inputDoms[index];
    if (inputElement.value) {
      inputElement.select();
    }
  }

  inputBlur(index: number) {
    this.curIndex = -1;
  }

  lastInput(index: number) {
    const lastIndex: number = index == 0 ? index : index - 1;
    const lastInput = this.inputDoms[lastIndex];
    lastInput.focus();
  }

  nextInput(index: number) {
    const nextIndex: number = index == this.ncLength - 1 ? index : index + 1;
    const nextInput = this.inputDoms[nextIndex];
    nextInput.focus();
  }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (JSON.stringify(v) !== JSON.stringify(this.innerValue)) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  // 从模型写入值到视图
  writeValue(value: any): void {
    if (JSON.stringify(value) !== JSON.stringify(this.innerValue)) {
      this.innerValue = value;
      this.cd.markForCheck();
    }
  }

  // 注册 onChange 事件
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  // 注册 onTouched 事件
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  onInputChange(index: number, event: any): void {
    //integerOnlyMode下非数字置空
    if (this.ncIntegerOnly && isNaN(Number(event))) {
      const inputElement = this.inputDoms[index];
      inputElement.value = '';
      event = '';
    }
    let temp = [...this.value];
    //补齐数组
    while (temp.length < this.ncLength) {
      temp.push(null);
    }
    if (temp.length > this.ncLength) {
      temp = temp.slice(0, this.ncLength);
    }
    temp.splice(index, 1, event == '' ? null : (isNaN(Number(event)) ? event : Number(event)));
    this.value = [...temp];//执行set value
  }
}
